<et-step-layout [data]="data">
  <div class="flex mb-4 justify-content-between align-items-end">
    <div class="title3Font"
         i18n>Checklist</div>
    @if (createdDateTime !== null) {
      <div>
        <span i18n>Submitted on {{ createdDateTime | date:'y-m-d-t' }}</span>
      </div>
    }
  </div>

  @if (form) {
    <form [formGroup]="form"
          (ngSubmit)="submitChecklist()"
          class="et-checklist-form">
      <div class="et-checklist-form-fields">
        @for (checkboxItem of checkboxItems; track checkboxItem; let i = $index; let last = $last) {
          <div class="field field-checkbox py-3">
            <p-checkbox scValidatable
                        [inputId]="'checkbox' + i"
                        [binary]="true"
                        [formControl]="checkboxItem.checkbox">
            </p-checkbox>
            <label [for]="'checkbox' + i"
                   [innerHTML]="checkboxItem.item.templateItem.itemText">
            </label>
            @if (!checkboxItem.item.templateItem.isRequired) {
              <span i18n
                    class="et-optional caption1Font">Optional</span>
            }
          </div>
          @if (!last) {
            <p-divider></p-divider>
          }
        }
      </div>
      @if (createdDateTime === null && !isReadonly) {
        <div class="flex justify-content-between align-items-center mt-5">
          @if (showWarning) {
            <p-message severity="error"
                       text="Please, complete previous steps to have an opportunity checklist submission."
                       class="warning-message subtitle3Font"
                       i18n-text>
            </p-message>
          }
          <p-button scSubmitButton
                    [requestInProcess]="requestInProcess"
                    [disabled]="showWarning"
                    label="Submit"
                    i18n-label>
          </p-button>
        </div>
      }
    </form>
  }
</et-step-layout>